export async function fetchPermalinkReport(id: string) {
  const response = await fetch(`/api/permalinks/${id}`);
  if (!response.ok) return {};

  return response.json();
}
